export default __webpack_public_path__ + "static/media/img7.f15d3a65.PNG";